import { CommonModule, NgFor } from '@angular/common';
import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { TranslateModule } from '@ngx-translate/core';
import { ToastrService } from 'ngx-toastr';

import { Client, GuidDictionaryItem, LimitType } from '../../../../../../../api/api-reference';
import { FilterPanelComponent } from '../../filter-panel.component';

export interface LoadLimitFilterOutput {
  selectedRegions: string[];
  selectedLimitTypes: string[];
}

@Component({
  selector: 'app-load-limit-filter',
  standalone: true,
  imports: [CommonModule, NgFor, TranslateModule, FilterPanelComponent],
  templateUrl: './load-limit-filter.component.html',
  styleUrl: './load-limit-filter.component.scss',
})
export class LoadLimitFilterComponent implements OnInit {
  @Input() numberOfResults: number = 0;
  @Input() selectedRegions: string[] = [];
  @Input() selectedLimitTypes: string[] = [];

  @Output() applied = new EventEmitter<LoadLimitFilterOutput>();

  regions: GuidDictionaryItem[] = [];

  readonly limitTypes = Object.values(LimitType);

  draftRegions: string[] = [];
  draftLimitTypes: string[] = [];

  get activeFilterCount(): number {
    return this.selectedRegions.length + this.selectedLimitTypes.length;
  }

  constructor(private client: Client, private toastr: ToastrService) {}

  ngOnInit(): void {
    this.reset();
    this.client.getAllRegionsForOptions().subscribe({
      next: (res) => (this.regions = res ?? []),
      error: (err) => this.toastr.error(err),
    });
  }

  isIn<T>(list: T[], item: T): boolean {
    return list.includes(item);
  }

  toggle<T>(list: T[], item: T): T[] {
    return list.includes(item) ? list.filter((i) => i !== item) : [...list, item];
  }

  toggleGuid(list: string[], item: GuidDictionaryItem): string[] {
    const val = item.value!;
    return list.includes(val) ? list.filter((v) => v !== val) : [...list, val];
  }

  onApply(): void {
    this.applied.emit({
      selectedRegions: this.draftRegions,
      selectedLimitTypes: this.draftLimitTypes,
    });
  }

  onCancel(): void {
    this.reset();
  }

  private reset(): void {
    this.draftRegions = [...this.selectedRegions];
    this.draftLimitTypes = [...this.selectedLimitTypes];
  }
}
